import Vue from 'vue'

export default {
    updateContact(params) {
        return Vue.axios.post(`/pages/contact/update`, params)
    },
    getContact() {
        return Vue.axios.get(`/pages/contact`)
    },
    updateInfo(params) {
        return Vue.axios.post(`/pages/info/update`, params)
    },
    getInfo() {
        return Vue.axios.get(`/pages/info`)
    },
    updatePartnership(params) {
        return Vue.axios.post(`/pages/partnership/update`, params)
    },
    getPartnership() {
        return Vue.axios.get(`/pages/partnership`)
    },
    updatePaymentDelivery(params) {
        return Vue.axios.post(`/pages/payment-delivery/update`, params)
    },
    getPaymentDelivery() {
        return Vue.axios.get(`/pages/payment-delivery`)
    },
}
